import { AdvisePricingModel } from '../../types/advise';

export const pricingModelLabel = (value: string): string =>
  value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const PRICING_MODEL_OPTIONS = Object.values(AdvisePricingModel).map((value) => ({
  value,
  label: pricingModelLabel(value)
}));
